import React from 'react';
import { Select } from 'components/Form';
import { useTranslation } from 'react-i18next';
import { Box } from '@chakra-ui/react';

const RoundTimeSelect = ({ options, label }) => {
  const { t } = useTranslation();

  return (
    <Box w="full">
      <Select
        name="gameSettings.roundTime"
        options={options}
        label={label || t('Time for round')}
        placeholder={t('Select time...')}
      />
    </Box>
  );
};

export default RoundTimeSelect;
